import React from "react";

const IconoInstagram = ({ isActive }) => {
  return (
    <svg width="32" height="29" viewBox="0 0 32 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.21973 9.66634C5.21973 8.38446 5.76968 7.15508 6.74861 6.24866C7.72754 5.34223 9.05525 4.83301 10.4397 4.83301H20.8795C22.2639 4.83301 23.5916 5.34223 24.5706 6.24866C25.5495 7.15508 26.0995 8.38446 26.0995 9.66634V19.333C26.0995 20.6149 25.5495 21.8443 24.5706 22.7507C23.5916 23.6571 22.2639 24.1663 20.8795 24.1663H10.4397C9.05525 24.1663 7.72754 23.6571 6.74861 22.7507C5.76968 21.8443 5.21973 20.6149 5.21973 19.333V9.66634Z"
        stroke={isActive ? "#458898" : "#555555"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.532 9.0625V9.07458M11.7446 14.5C11.7446 15.4614 12.1571 16.3834 12.8913 17.0633C13.6255 17.7431 14.6213 18.125 15.6596 18.125C16.6979 18.125 17.6937 17.7431 18.4279 17.0633C19.1621 16.3834 19.5745 15.4614 19.5745 14.5C19.5745 13.5386 19.1621 12.6166 18.4279 11.9367C17.6937 11.2569 16.6979 10.875 15.6596 10.875C14.6213 10.875 13.6255 11.2569 12.8913 11.9367C12.1571 12.6166 11.7446 13.5386 11.7446 14.5Z"
        stroke={isActive ? "#458898" : "#555555"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconoInstagram;
